import { TwoFactorSmsConfirm } from "@/components/Portal/UserAccount/Security/TwoFactorSmsConfirm";
import { useResendActionForSmsSetup } from "@/hooks/useResendSms";

export const TwoFactorConfirmSmsView = () => (
  <div>
    <TwoFactorSmsConfirm useResendAction={useResendActionForSmsSetup} />
  </div>
);
